import './whatsapp_media_message_content.js.coffee'

Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.WhatsappDocumentMessageContent extends Monitoring.Models.SocialContents.WhatsappMediaMessageContent

  getMainText: ->
    @json.whatsappMessage.caption

  getDocumentType: ->
    mime = @json.attachment.mimeType
    switch mime
      when "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/msword" then "docx"
      when "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel" then "xlsx"
      when "application/vnd.openxmlformats-officedocument.presentationml.presentation", "application/vnd.ms-powerpoint" then "pptx"
      when "application/pdf" then "pdf"
      when 'video/mp4' then "mp4"
      else ""
